import React from 'react';
import {Badge, Media} from 'react-bootstrap';
import MakeMediaRead from '../common/MakeMediaRead.jsx';

const NotificationsItem = (props) => {
  function createCommentMarkup() {
    if (props.comment){
      return {__html: props.comment};
    }
  }

  return <MakeMediaRead onRead={props.onRead}>
    <Media className={'media-border-bottom my-3 ' + (props.read ? '' : 'media-unread')} data-id={props.id}>
      <img width={60} height={60} className="align-self-start rounded mr-3" src={props.sender_avatar} alt="avatar"/>
      <Media.Body className='flex-wrap'>
        <p>
          <i className={'icon ' + props.icon}></i>
          <a href={props.sender_url} className='font-weight-bold'>{props.sender_name}</a> {props.content} { (props.type !== 'like' && props.type !== 'dislike') && <a href={props.object_url} className='small text-orange'>{gettext('Читать') } >></a> }
        </p>
        { props.comment && <blockquote dangerouslySetInnerHTML={ createCommentMarkup() } className="blockquote small"></blockquote> }
        <p className='text-muted small'>
          {!props.read && <div className='float-right small d-inline-block d-sm-none'><Badge variant='success'>New</Badge></div>} {props.date}
        </p>
      </Media.Body>
      {!props.read && <div className='float-right small d-none d-sm-block'><Badge variant='success'>New</Badge></div>}
    </Media>
  </MakeMediaRead>
};

export default NotificationsItem;

